import { useSelector } from 'react-redux';

export const useGetTilePosition = ({ campaignContainer, uuid }) => {
  const tiles = useSelector(
    state => state.campaignDnd[campaignContainer] || [],
  );
  const tileCount = tiles.length;
  const currentPosition = tiles.map(({ id }) => id).indexOf(uuid);

  return { tileCount, currentPosition };
};
